"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KoraMessage = void 0;
var _SVG = require("../SVG");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const KoraMessage = _ref => {
  let {
    color = "#3667E9",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: color,
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.722 4.333c5.306 0 9.612 4.338 9.612 9.663s-4.306 9.664-9.612 9.664h-7.347l-.209.202-.01.01-3.743 3.523a1 1 0 0 1-1.685-.729v-3.672l-.513-.243-.314-.154a9.705 9.705 0 0 1-5.234-8.6c0-5.326 4.306-9.664 9.612-9.664h9.443Zm-9.443 2c-4.19 0-7.612 3.432-7.612 7.663 0 2.963 1.729 5.69 4.397 6.944l.004.002 1.088.517.572.271v2.622l2.056-1.936.49-.475.291-.28h8.157c4.19 0 7.612-3.434 7.612-7.665s-3.422-7.663-7.612-7.663h-9.443Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.47 12.525 21 13.998l-3.53 1.473L15.999 19l-1.473-3.53L11 13.999l3.525-1.473L15.998 9l1.473 3.525Z"
  }));
};
exports.KoraMessage = KoraMessage;
KoraMessage.displayName = "KoraMessage";